<div class="st-page">
  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'staffSearchTitle' | translate }}</h1>
      <p class="st-subtitle">{{ 'findAnyStudentOrStaffMember' | translate }}</p>
    </div>
  </div>

  <div class="ss-search-box">
    <i class="ri-search-line"></i>
    <input
      type="text"
      [ngModel]="query"
      (ngModelChange)="onChangedText($event)"
      (keyup.enter)="doSearch()"
      placeholder="{{ 'bv2SearchViewersPlaceholder' | translate }}"
    />
    <i class="ri-close-line ss-clear-icon" *ngIf="query" (click)="clearSearch()"></i>
  </div>

  <div class="st-tabs">
    <div class="st-tab" [class.active]="filter === 'ALL'" (click)="setFilterValue('ALL')">{{ 'all' | translate }}</div>
    <div class="st-tab" [class.active]="filter === 'STUDENT'" (click)="setFilterValue('STUDENT')">{{ 'students' | translate }}</div>
    <div class="st-tab" [class.active]="filter === 'STAFF'" (click)="setFilterValue('STAFF')">{{ 'staff' | translate }}</div>
  </div>

  <div class="st-tv-list" *ngIf="isFetching">
    <div class="st-card ss-skeleton-row" *ngFor="let s of [1,2,3,4]"></div>
  </div>

  <ng-container *ngIf="!isFetching">
    <div class="st-card" *ngIf="results.length">
      <div class="st-list-row" *ngFor="let r of results" (click)="openResult(r)">
        <div class="st-avatar">
          <img *ngIf="displayImage(r)" [src]="displayImage(r)" [alt]="displayName(r)" />
          <ng-container *ngIf="!displayImage(r)">{{ displayName(r).charAt(0) }}</ng-container>
        </div>
        <div class="st-list-text">
          <div class="st-list-title">{{ displayName(r) }}</div>
          <div class="st-list-sub">{{ displaySubtitle(r) }}</div>
        </div>
        <span class="st-chip st-chip-grey" *ngIf="r.userType !== 'STUDENT'">{{ 'staff' | translate }}</span>
      </div>
    </div>

    <div class="st-empty-state" *ngIf="!results.length && hasSearched">
      <i class="ri-search-line"></i> {{ 'noMatchingResultFound' | translate }}
    </div>

    <div class="st-empty-state" *ngIf="!results.length && !hasSearched">
      <i class="ri-search-line"></i> {{ 'searchProfileText' | translate }}
    </div>
  </ng-container>
</div>
